import { PropsWithChildren } from 'react';
import { modalTitle } from '../../../../../styled-system/recipes';
import { CloseX } from '../../../../icons/CloseX';
import { H1 } from '../../../font/headings/components/H1';
import { IconButton } from '../../../form/buttons/button/component/IconButton';

export interface ModalTitleProps {
  onClose: () => void;
}

export const ModalTitle = ({
  children,
  onClose,
}: PropsWithChildren<ModalTitleProps>) => {
  return (
    <H1 className={modalTitle()}>
      {children}
      <IconButton css={{ paddingTop: '0' }} onClick={onClose}>
        <CloseX />
      </IconButton>
    </H1>
  );
};
